import { Component, computed, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropdownInterface } from 'flowbite';
import { Router, NavigationEnd } from '@angular/router';
import { AuthService } from "../../services";
import { filter } from 'rxjs/operators';
import { PermissionFlagsService } from "../../services/permissionFlags.service";

@Component({
    selector: 'app-header',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './app-header.component.html',
    styleUrl: './app-header.component.scss'
})
export class AppHeaderComponent implements OnInit {
    authService = inject(AuthService);
    permissionFlags = inject(PermissionFlagsService);
    public router = inject(Router);

    dropdown: DropdownInterface | null = null;
    activeButton = '';

    private allNavButtons = [
        { label: 'Task Tracker',        route: 'task',                flag: 'canAccessTask'                 },
        { label: 'Product Library',     route: 'product-library',     flag: 'canAccessProductLibrary'        },
        { label: 'Production Data',     route: 'production-data',     flag: 'canAccessProductionData'        },
        { label: 'Pre-press Jobs',      route: 'prepress-jobentry',   flag: 'canAccessPrepressJobentry'      },
        { label: 'Artwork Library',     route: 'product-development', flag: 'canAccessProductDevelopment'    },
        { label: 'Pre-press Dashboard', route: 'prepress-dashboard',  flag: 'canAccessPrePressDashboard'     },
        // No identity-service resource yet — the ink-kitchen API is unauthenticated
        { label: 'Ink Kitchen',         route: 'ink-kitchen',         flag: 'canAccessInkKitchen'            },
    ] as const;

    filteredButtons = computed(() =>
        this.allNavButtons.filter(btn => !btn.flag || this.permissionFlags.flags[btn.flag]())
    );

    selectedLabel = computed(() => {
        const active = this.allNavButtons.find(b => b.route === this.activeButton);
        return active?.label ?? 'Select Item';
    });

    ngOnInit() {
        this.updateActiveButton(this.router.url);
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            this.updateActiveButton(event.urlAfterRedirects);
        });
    }

    private updateActiveButton(url: string) {
        const route = url.substring(1).split('/')[0];
        this.activeButton = route;
    }

    navigate(route: string) {
        this.router.navigate([route]);
        this.dropdown?.hide();
    }

    logout() {
        this.authService.logout();
    }
}